import { lazy } from "react";
import { Grid } from "@mui/material";
import { isEmpty, filter } from "lodash";
import BarsLockedSlots from "../calendarTiles/barsLockedSlots";

const SessionColumn = lazy(() => import("../calendarTiles/sessionColumn"));
const PatientAssignableSlots = lazy(
  () => import("../calendarTiles/patientAssignableSlots"),
);
const AppointmentSlots = lazy(
  () => import("../calendarTiles/appointmentSlots"),
);

export default function CalendarColumn({
  OFFSET_LEFT,
  columnBarsSlots,
  date,
  reviewsToday,
  columnWidth,
  session,
}) {
  const emptySlots = filter(reviewsToday, (sl) => !sl?.status);

  return (
    <Grid
      item
      style={{
        flexBasis: columnWidth,
        position: "relative",
      }}
    >
      {session && (
        <SessionColumn
          date={date}
          colWidth="100%"
          session={session}
        />
      )}

      {!isEmpty(reviewsToday) && (
        <AppointmentSlots
          colWidth="100%"
          isDraggable={true}
          session={session}
          reviews={reviewsToday}
          leftOffset={OFFSET_LEFT}
        />
      )}

      {!isEmpty(columnBarsSlots) && (
        <BarsLockedSlots date={date} colWidth="100%" events={columnBarsSlots} />
      )}

      <PatientAssignableSlots
        colWidth="100%"
        session={session}
        emptySlots={emptySlots}
      />
    </Grid>
  );
}
